import React from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import alirajabi from "../../../Assets/Image/png/alirajabi.png";
import { FaLinkedinIn, FaEnvelope } from "react-icons/fa";
import { BtnPrimary } from "../../share/buttons/Btn";

function MyTeamModal({ close }) {
  return (
    <div className="AddnewsupportTicket relative max-w-[73rem]">
      {" "}
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center">
        پروفایل
      </p>
      <div className=" mt-[5.6rem] flex flex-row items-center justify-start">
        <div className=" flex flex-col items-center justify-start">
          <img
            src={alirajabi}
            alt="alirajabi"
            className="rounded-full max-w-[11.9rem] max-h-[11.9rem]"
          />
          <div className=" flex flex-row items-center mt-[1.2rem]">
            <FaEnvelope className=" rounded-50 text-white bg-[#21212182] w-[3rem] h-[3.25rem] py-[0.9rem]" />
            <FaLinkedinIn className=" rounded-50 text-white bg-[#21212182] w-[3rem] h-[3.25rem] py-[0.9rem] mr-[1.2rem]" />
          </div>
        </div>
        <div className=" mr-[2.7rem]">
          <p className=" text-[#212121E5] text-[1.6rem] font-bold leading-[3.2rem]">
            علی رجبی
          </p>
          <p className=" text-[#21212199] text-[1.4rem] font-normal leading-[2.4rem]">
            مدیر کسب و کار
          </p>
          <p className=" text-[#212121E5] text-[1.4rem] font-normal leading-[2.4rem]">
            لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
            استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله در
            ستون و سطرآنچنان که لازم است،
          </p>
        </div>
      </div>
      <div className=" text-left mt-[2rem]">
        <BtnPrimary text="ارسال پیام به علی" className="px-16 py-7" />
      </div>
    </div>
  );
}

export default MyTeamModal;
